export const prizeStatuses = [
  { id: 'free', value: 'Free' },
  { id: 'reserved', value: 'Reserved' },
  { id: 'emitted', value: 'Emitted' }
]
